import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function SocialProofSection() {
  const quotes = ['If 4PM scares you, you’re not alone.', 'You’re not failing—your child is depleted.', 'Stop trying to teach during a nervous system crash.', 'Behavior gets loud when needs go unheard.', 'Meltdowns aren’t disrespect. They’re overload.', 'The first 15 minutes decide the whole evening.', 'You can be kind and firm—without the lecture.', 'Your calm isn’t a personality trait. It’s a plan.', 'You don’t need more patience. You need less friction.', 'The goal isn’t perfect kids. It’s a peaceful home.'];
  return <section className="py-20 bg-sage-dark text-cream-100 overflow-hidden" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4" data-id="element-234">
        <div className="text-center mb-12" data-id="element-235">
          <Quote className="w-12 h-12 mx-auto text-sage-light/30 mb-4" data-id="element-236" />
          <h2 className="text-2xl md:text-3xl font-serif text-cream-50" data-id="element-237">
            Reminders for the Hard Days
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-238">
          {quotes.map((quote, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className={`
                px-6 py-4 rounded-full border border-sage-light/20 bg-white/5 backdrop-blur-sm
                hover:bg-white/10 hover:border-sage-light/40 transition-all cursor-default
                ${i % 3 === 0 ? 'bg-terracotta/10 border-terracotta/20' : ''}
              `} data-id="element-239">
              <p className="text-lg md:text-xl font-medium text-center" data-id="element-240">
                {quote}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}